module.exports = __webpack_public_path__ + "img/818-265970.png";